module.exports = __webpack_public_path__ + "static/media/maker_launch_amber.f01a7f9a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Illustration/img/maker_launch_amber.svg
// module id = 1099
// module chunks = 2